import script from "./MarkdownWysiwyg.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownWysiwyg.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownWysiwyg.vue?vue&type=style&index=0&id=1846d1e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1846d1e2"]])

export default __exports__